import { create } from 'zustand';

import { endOfAppDay, startOfAppDay } from '@/utils/spain-time';

export type ProgramBroadcastFiltersState = {
  rowsPerPage: number;
  offset: number;
  order_by: string;
  gte: string;
  lte: string;
  startDatetimeGte: string;
  endDatetimeLte: string;
  startDatetimeLte: string;
  endDatetimeGte: string;
  search: string;
  channelType: string;
  projectSearch: string;
  tagSearch: string;
  review_states: number[];
  time_keeping_states: number[];
  workspaces: string[];
  projects: string[];
  tags: string[];
  logos: string[];
  broadcasters: string[];
  programs: string[];
  people: string[];
  clients: string[];
  audienceChannelSource: string;
  isStreaming: boolean;
  /**
   * RISK: the only signal that the user applied a date range, and the only trigger of dropping
   * selections the new range makes inactive. Any control that lets the user change the range
   * must increment it in the same update that writes gte/lte. Not synced to the URL.
   */
  rangeApplyCount: number;
  setFilters: (newFilters: Partial<ProgramBroadcastFiltersState>) => void;
  clearFilters: () => void;
};

/** Start of the Madrid day, whatever the viewer's timezone (RCOMM-6264). */
function getStartOfTodayISO(): string {
  return startOfAppDay().toISOString();
}

/** End of the Madrid day, whatever the viewer's timezone (RCOMM-6264). */
function getEndOfTodayISO(): string {
  return endOfAppDay().toISOString();
}

const getDefaultFilters = (): Omit<
  ProgramBroadcastFiltersState,
  'clearFilters' | 'setFilters'
> => ({
  rowsPerPage: 10,
  offset: 0,
  order_by: '',
  gte: getStartOfTodayISO(),
  lte: getEndOfTodayISO(),
  search: '',
  channelType: '',
  projectSearch: '',
  tagSearch: '',
  endDatetimeLte: '',
  startDatetimeGte: '',
  startDatetimeLte: '',
  endDatetimeGte: '',
  review_states: [],
  time_keeping_states: [],
  workspaces: [],
  projects: [],
  tags: [],
  logos: [],
  broadcasters: [],
  programs: [],
  people: [],
  clients: [],
  audienceChannelSource: '',
  isStreaming: false,
  rangeApplyCount: 0,
});

export const useProgramBroadcastFilters = create<ProgramBroadcastFiltersState>(set => ({
  ...getDefaultFilters(),
  setFilters: newFilters => set(state => ({ ...state, ...newFilters })),
  clearFilters: () => set(getDefaultFilters()),
}));
